<template>
    <div class="language-selector">
      <label for="language" class="sr-only">Select Language</label>
      <select
        id="language"
        :value="language"
        @change="updateLanguage"
        aria-label="Language Selector"
      >
        <option class="nes-pointer" v-for="(language, code) in languages" :key="code" :value="code">
          {{ language.flag }}
        </option>
      </select>
    </div>
  </template>
  
  <script>
  import { useAppStore } from '../stores/app';
  
  export default {
    setup() {
      const appStore = useAppStore();
      const languages = {
        en: {name: 'English', flag: '🇬🇧'},
        fr: {name: 'Français', flag: '🇫🇷'},
        es: {name: 'Español', flag: '🇪🇸'},
        de: {name: 'Deutsch', flag: '🇩🇪'},
        jp: {name: '日本語', flag: '🇯🇵'},
        ru: {name: 'русский', flag: '🇷🇺'},
      };
  
      const updateLanguage = (event) => {
        appStore.setLanguage(event.target.value);
      };
  
      return {
        languages,
        language: appStore.language,
        updateLanguage,
      };
    },
  };
  </script>
  
  <style scoped>
  .language-selector {
    font-family: 'Press Start 2P';
    color: #fff;
    padding: 10px;
    display: inline-block;
  }

  .language-selector select {
    width: 100%;
    cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAzElEQVRYR+2X0Q6AIAhF5f8/2jYXZkwEjNSVvVUjDpcrGgT7FUkI2D9xRfQETwNIiWO85wfINfQUEyxBG2ArsLwC0jioGt5zFcwF4OYDPi/mBYKm4t0U8ATgRm3ThFoAqkhNgWkA0jJLvaOVSs7j3qMnSgXWBMiWPXe94QqMBMBc1VZIvaTu5u5pQewq0EqNZvIEMCmxAawK0DNkay9QmfFNAJUXfgGgUkLaE7j/h8fnASkxHTz0DGIBMCnBeeM7AArpUd3mz2x3C7wADglA8BcWMZhZAAAAAElFTkSuQmCC) 14 0, pointer;
  }
  
  select {
    background: #000;
    border-color: black;
    color: #fff;
    padding: 5px;
    font-family: inherit;
    font-size: 14px;
    outline: none;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  </style>
  